import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Env } from '../env';
import { UserDto } from '../dto/user.dto';
import { UserUpdateDto } from '../dto/userUpdate.dto';
import { Observable } from 'rxjs/Observable';
import { User } from '../models/user';

@Injectable()
export class UserService {

  constructor(private http: HttpClient, private global: Env) { }


  getAll(size, page, email, role): Observable<User[]> {
    const url = this.global.user + '/?pageSize=' + size + '&page=' + page + '&email=' + email + '&role=' + role;
    return this.http.get(url).map((res: User[]) => {
      return res;
    });
  }

  getUserMe(): Observable<User> {
    const url = this.global.user + '/me';
    return this.http.get(url).map((res: User) => {
      return res;
    });
  }

  getInfoDetail(id: number): Observable<User> {
    const url = this.global.user + '/' + id;
    return this.http.get(url).map((res: User) => {
      return res;
    });
  }

  createUser(dto: UserDto): Observable<User> {
    const url = this.global.user;
    return this.http.post(url, JSON.stringify(dto)).map((res: User) => {
      return res;
    });
  }

  updateUser(id: number, dto: UserUpdateDto): Observable<User> {
    const url = this.global.user + '/' + id;
    return this.http.post(url, JSON.stringify(dto)).map((res: User) => {
      return res;
    });
  }

  deleteUser(id: number): any {
    const url = this.global.user + '/delete/' + id;
    this.http.post(url, null).subscribe(
      data => {
        return data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('Ocurrió un error:', err.error.message);
        } else {
          console.log('Backend devuelto código de estado: ', err.status);
          console.log('Response body:', err.error);
        }
      }
    );
  }

  getUserAddress(id: number) {
    const url = this.global.user + '/' + id + '/address';
    return this.http.get(url).map((res) => {
      return res;
    });
  }

  report(email, role, status, page, size) {
    const url = this.global.user + '/report/?&email=' + email + '&role=' + role + '&status=' + status + '&page=' + page + '&size=' + size;
    return this.http.get(url, {responseType: 'blob'});
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/user.service.ts